import type { FaireProductEntity } from "../../entity_types/product";

export const p_nh9xq3pf5x: FaireProductEntity = {
  token: "p_nh9xq3pf5x",
  type: "product",
  name: "Personalized Kids Charm Pink Trucker Hat (Mama & Mini Match)",
  brandToken: "b_phs269hs3m",
  brandName: "Sundrop",
  imageUrl:
    "https://cdn.faire.com/fastly/e27748a47e36fbac0e16ccb3fb175c30d15361eeea2b7b5142e54b06167162cd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f7f3d3d364c26061b7dd3be89650608e3220c949ab35e4a586d1f54bf2cf465d.jpeg",
    "https://cdn.faire.com/fastly/70cc16d328167fc74c549b94e5708942f5d62b161e32b67ff44a97e4aa531f85.jpeg",
    "https://cdn.faire.com/fastly/0d423e87c0305ec16c36168b0b3ec7cd466bebd450b069e3173d378754282eb3.jpeg",
    "https://cdn.faire.com/fastly/93129a01ca0ec42affc7e295b0509dac5cc5479de493660053b585564b36a8d4.jpeg",
    "https://cdn.faire.com/fastly/353758500a4a655a4f67e6b3112c35422c34aa703c16d543f455a79de7338c68.jpeg",
    "https://cdn.faire.com/fastly/77c3909d648fd7f0e2455af25dc97a5542ff575092e39d27f0f54ec617202ea8.jpeg",
    "https://cdn.faire.com/fastly/36550fc1f25d23a84614b09b820e2cc00fd2eb3eded5c0f9ae293f99b2638799.jpeg",
    "https://cdn.faire.com/fastly/6e5faeba10083efdaf3f94b57fdcd475f81bbb973b0ae77180db5287f1bf4c8d.jpeg",
    "https://cdn.faire.com/fastly/5051a8a432c41dce951d4ed20f6fa32e9a9c0df3b7f994c1b0d07c7af1059869.jpeg",
    "https://cdn.faire.com/fastly/d017e0fc80910b0a43fa0b5e9305c6fa9269524af6b3b0b84ad8afd8ba54c413.jpeg",
    "https://cdn.faire.com/fastly/5ff75ac66e83c4b4301e7c1bc2f45090c07feffae38da1af1e6653cb638165b1.jpeg",
    "https://cdn.faire.com/fastly/936319e8bf2f2cb21fd3610de440dcaea513f976737e362a70c5ac060ff28c4c.jpeg",
  ],
  priceDollars: 18,
  description:
    'Personalized Kids Charm Pink Embroidered Trucker Hat \n\nMake every outfit extra special with our Personalized Kids Charm Pink Embroidered Trucker Hat in light pink! Personalize it with your child\'s name in a stylish script, surrounded by playful embroidered charms including a rainbow, stars, cherries, a smiley face, lightning bolt, heart, and daisy. Designed for comfort and style, this trucker hat features a breathable mesh back, a soft terrycloth band, a trendy rope detail on the brim, and an adjustable snapback closure for a perfect fit.\n\nWhether for sunny playdates, family vacations, or a unique everyday accessory, this hat is a fun way to let your little one\'s personality shine.\n\n*We also offer a matching "Mama" hat to match your mini!\n\nHats measure approximately 21-23.5" with plastic snap closure. It is possible to have them tighter. However, the plastic will overhang and not be snapped on all places.',
  tags: [],
  msrpDollars: 33.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:29.315Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
